import { render } from "./RolesPermissionsSyncButton.vue?vue&type=template&id=4792dea6"
import script from "./RolesPermissionsSyncButton.vue?vue&type=script&lang=js"
export * from "./RolesPermissionsSyncButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__